(() => {
  const setup = (scope = document) => {
    const headers = scope.matches?.('[data-rp-mega-menu]') ? [scope] : scope.querySelectorAll('[data-rp-mega-menu]');
    headers.forEach((header) => {
      if (header.dataset.rpMenuReady) return;
      header.dataset.rpMenuReady = 'true';
      customElements.whenDefined('dropdown-component').then(() => {
        if (!header.isConnected) return;
        const menus = [...header.querySelectorAll('.rp-mega-menu')];
        const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
        let closeTimer;
        const closeAll = () => menus.forEach((menu) => menu.close?.());
        menus.forEach((menu, index) => {
          const trigger = menu.querySelector('[data-ref="dropdown-toggle"]');
          const panel = menu.querySelector('[data-ref="dropdown-content"]');
          if (!trigger || !panel) return;
          const identifier = `rp-mega-${header.closest('.shopify-section')?.id || 'header'}-${index}`;
          trigger.id = `${identifier}-toggle`;
          panel.id = `${identifier}-panel`;
          trigger.setAttribute('aria-controls', panel.id);
          trigger.setAttribute('aria-expanded', String(menu.dataset.open === 'true'));
          panel.setAttribute('aria-labelledby', trigger.id);
          const observer = new MutationObserver(() => trigger.setAttribute('aria-expanded', String(menu.dataset.open === 'true')));
          observer.observe(menu, { attributes: true, attributeFilter: ['data-open'] });
          let openTimer;
          menu.addEventListener('mouseenter', () => {
            if (!hover.matches) return;
            clearTimeout(closeTimer);
            openTimer = setTimeout(() => { closeAll(); menu.open?.(); }, 180);
          });
          menu.addEventListener('mouseleave', () => {
            clearTimeout(openTimer);
            if (hover.matches) closeTimer = setTimeout(() => menu.close?.(), 220);
          });
          trigger.addEventListener('click', () => clearTimeout(openTimer));
        });
        header.addEventListener('focusout', () => setTimeout(() => {
          if (!header.contains(document.activeElement)) closeAll();
        }, 0));
        const overlay = header.querySelector('[data-ref="mobile-menu-overlay"]');
        const drawer = header.querySelector('[data-ref="mobile-menu"]');
        const toggle = header.querySelector('[data-ref="menu-toggle"]');
        const close = header.querySelector('[data-ref="menu-close"]');
        if (drawer && overlay && toggle) {
          drawer.id = `rp-mobile-${header.closest('.shopify-section')?.id || 'header'}`;
          drawer.setAttribute('role', 'dialog');
          drawer.setAttribute('aria-modal', 'true');
          drawer.setAttribute('aria-label', toggle.getAttribute('aria-label') || 'Menu');
          toggle.setAttribute('aria-controls', drawer.id);
          const syncDrawer = () => {
            const open = overlay.classList.contains('is-open');
            toggle.setAttribute('aria-expanded', String(open));
            overlay.setAttribute('aria-hidden', String(!open));
            drawer.inert = !open;
          };
          new MutationObserver(syncDrawer).observe(overlay, { attributes: true, attributeFilter: ['class'] });
          syncDrawer();
          const roots = [...drawer.querySelectorAll('.header__mobile-menu-nav > .accordion-animation > details')];
          roots.forEach((detail) => {
            detail.addEventListener('toggle', () => {
              if (!detail.open) return;
              roots.filter((other) => other !== detail).forEach((other) => { other.open = false; });
              const target = detail.querySelector(':scope > .header__mobile-menu-submenu');
              if (!target || target.querySelector(':scope > .rp-mobile-menu-cards')) return;
              const title = detail.querySelector(':scope > summary .header__mobile-menu-link-text')?.textContent.trim();
              const source = menus.find((menu) => menu.querySelector('.header__menu-link-text')?.textContent.trim() === title);
              if (!source) return;
              const cards = document.createElement('div');
              cards.className = 'rp-mobile-menu-cards';
              [...source.querySelectorAll('.rp-menu-card')].slice(0, 2).forEach((card) => {
                const copy = card.cloneNode(true);
                copy.removeAttribute('data-shopify-editor-block');
                copy.removeAttribute('id');
                cards.append(copy);
              });
              target.append(cards);
            });
          });
          header.addEventListener('keydown', (event) => {
            if (event.key !== 'Tab' || !overlay.classList.contains('is-open')) return;
            const focusable = [...drawer.querySelectorAll('a[href], button, input, select, textarea, summary, [tabindex="0"]')].filter((element) => element.getClientRects().length && !element.disabled);
            const first = focusable[0] || close;
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
          });
        }
        header.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const open = menus.find((menu) => menu.dataset.open === 'true');
          if (open) { event.preventDefault(); closeAll(); open.querySelector('[data-ref="dropdown-toggle"]')?.focus(); }
        });
        window.matchMedia('(max-width: 1000px)').addEventListener('change', closeAll);
      });
    });
  };
  if (!document.documentElement.dataset.rpMenuListener) {
    document.documentElement.dataset.rpMenuListener = 'true';
    document.addEventListener('shopify:section:load', (event) => setup(event.target));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();
})();
